<template>
  <div class="stats">
    <nav class="level is-mobile">
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">
            <a>{{ $t("dashboard.doors") }}</a>
          </p>

          <p class="title has-cursor-pointer">
            {{ locker.doors.length }}
          </p>
        </div>
      </div>

      <div
        class="level-item has-text-centered"
        v-if="permissions.seeOpenDeliveries"
      >
        <div>
          <p class="heading" @click="lockerDeliveries('open-deliveries')">
            <a>{{ $t("dashboard.currentDeliveries") }}</a>
          </p>

          <p
            class="title has-cursor-pointer"
            @click="lockerDeliveries('open-deliveries')"
          >
            {{
              locker.doors.filter(d => {
                return d.status === "busy";
              }).length
            }}
          </p>
        </div>
      </div>

      <div
        class="level-item has-text-centered"
        v-if="permissions.seeAllDeliveries"
      >
        <div>
          <p class="heading" @click="lockerDeliveries('all-deliveries')">
            <a>{{ $t("dashboard.allDeliveries") }}</a>
          </p>

          <p
            class="title has-cursor-pointer"
            @click="lockerDeliveries('all-deliveries')"
          >
            {{ allLockerDeliveriesQty }}
          </p>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../../mixins/common";

export default {
  props: ["locker"],

  mixins: [common],

  methods: {
    lockerDeliveries(filter) {
      this.$store.dispatch("setLockerDeliveriesFilter", filter);

      this.$store
        .dispatch("setLockerBeingManaged", this.locker)
        .then(() => {
          this.$router.push("/locker-deliveries");
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        });
    }
  },

  computed: {
    ...mapGetters(["permissions", "allLockerDeliveriesQty"])
  }
};
</script>

<style scoped>
.stats {
  margin: auto;
  margin-top: 1.5rem;
}
.has-cursor-pointer {
  cursor: pointer;
}
</style>
